import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FaTrash, FaEdit, FaArrowLeft } from 'react-icons/fa';
import Sidebar from '../component/Sidebar';
import Pagination from "../Master/Pagination";
import CollapsibleHeader from "../component/CollapsibleHeader";


const DesignationList = () => {
  const [designations, setDesignations] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("ALL");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(20);
  const navigate = useNavigate();

  const fetchDesignations = async () => {
    try {
      const res = await axios.get('/api/designations');
      console.log('Fetched designations:', res.data); // ✅ Debug
      setDesignations(res.data);
    } catch (err) {
      console.error('Fetch Designations Error:', err);
    }
  };

  useEffect(() => {
    fetchDesignations();
  }, []);

  const departments = ["ALL", ...new Set(designations.map(d => d.departmentName))];
//  Filter by Department
const filteredDesignations =
  selectedDepartment === "ALL"
    ? designations
    : designations.filter(d => d.departmentName === selectedDepartment);

// Pagination on filtered data
const indexOfLast =
  perPage === "all"
    ? filteredDesignations.length
    : currentPage * perPage;

const indexOfFirst =
  perPage === "all"
    ? 0
    : indexOfLast - perPage;

const currentdesignations =
  perPage === "all"
    ? filteredDesignations
    : filteredDesignations.slice(indexOfFirst, indexOfLast);

  const deleteDesignation = async (id) => {
    if (!window.confirm('Are you sure you want to delete this designation?'))
      return;
    try {
      await axios.delete(`/api/designations/${id}`);
      setDesignations(designations.filter((d) => d._id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
  <div className="flex h-screen flex-col md:flex-row">
      <Sidebar/>
    <div className="page-panel px-2 pb-1 bg-white shadow-md rounded-md">
      <div className="page-sticky-header bg-white ">
      <CollapsibleHeader title="Employee List Header" contentClassName="mt-1">
          <div className="page-title-bar">
            <div className="flex flex-col gap-3 xl:flex-row xl:items-end xl:justify-between">
              <div className="flex items-center justify-between gap-2">
                <h2 className="text-lg sm:text-xl font-bold text-dorika-blue whitespace-nowrap">
                  Designation
                </h2>
                <div className="xl:hidden">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="h-8 w-8 inline-flex items-center justify-center rounded-lg bg-blue-700 text-white shadow hover:bg-blue-800 transition"
                  >
                    <FaArrowLeft />
                  </button>
                </div>
              </div>

              <div className="grid grid-cols-1 gap-3 md:grid-cols-2 xl:flex xl:items-end">
                <div className="field-stack-mobile xl:w-[180px]">
                  <label>Department</label>
                  <select
                    value={selectedDepartment}
                    onChange={(e) => {
                      setSelectedDepartment(e.target.value);
                      setCurrentPage(1);
                    }}
                    className="h-8 border border-dorika-blue rounded px-3 py-1 text-sm bg-white font-semibold text-dorika-blue"
                  >
                    {departments.map((dep, index) => (
                      <option key={index} value={dep}>
                        {dep}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-stack-mobile xl:w-[120px]">
                  <label>Show</label>
                  <select
                    value={perPage}
                    onChange={(e) => {
                      const val = e.target.value;
                      setPerPage(val === "all" ? "all" : parseInt(val));
                      setCurrentPage(1);
                    }}
                    className="h-8 border border-dorika-blue rounded px-3 py-1 text-sm bg-white font-semibold text-dorika-blue"
                  >
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value="all">ALL</option>
                  </select>
                </div>

                <div className="flex items-center gap-3 md:col-span-2 xl:col-span-1">
                  <div className="hidden xl:block">
                    <button
                      type="button"
                      onClick={() => navigate(-1)}
                      className="h-8 w-[110px] inline-flex items-center justify-center gap-2 rounded-lg bg-blue-700 px-4 text-sm font-semibold text-white shadow hover:bg-blue-800 transition"
                    >
                      <FaArrowLeft />
                      <span>Back</span>
                    </button>
                  </div>
                  <button
                    onClick={() => navigate('/designationMaster')}
                    className="h-8 w-full xl:w-[180px] bg-dorika-orange hover:bg-dorika-blue text-white px-4 py-1 rounded font-semibold text-sm whitespace-nowrap"
                  >
                    Add Designation
                  </button>
                </div>
              </div>
            </div>
          </div>
        </CollapsibleHeader>
      </div>

      <div className="table-scroll-area">
      <table className="table-fixed-header mt-2 w-full table-auto border border-dorika-blue">
        <thead className="bg-dorika-blue text-white text-sm">
          <tr>
            <th className="border border-dorika-blue px-2">SL No</th>
            <th className="border border-dorika-blue px-2">Designation ID</th>
            <th className="border border-dorika-blue px-2">Designation Name</th>
            <th className="border border-dorika-blue px-2">Department</th>
            <th className="border border-dorika-blue px-2">Grade</th>
            <th className="border border-dorika-blue px-2">Status</th>
            <th className="border border-dorika-blue px-2">Action</th>
          </tr>
        </thead>
        <tbody className="text-xs sm:text-sm text-center">
          {designations.length > 0 ? (
           currentdesignations.map((d,index) => (
              <tr key={d._id} className="hover:bg-dorika-blueLight transition">
                <td className="border border-dorika-blue px-2 py-1">
                  {perPage === "all" ? index + 1 : (currentPage - 1) * perPage + index + 1}
                </td>
                <td className="border border-dorika-blue px-2">{d.designationID}</td>
                <td className="border border-dorika-blue px-2">{d.designationName}</td>
                <td className="border border-dorika-blue px-2">{d.departmentName}</td>
                <td className="border border-dorika-blue px-2">{d.grade}</td>
                <td className="border border-dorika-blue px-2">{d.status}</td>
                <td className="border border-dorika-blue px-2 ">
                <div className="flex justify-center gap-4 sm:gap-8">
                    <button
                    onClick={() =>
                      navigate('/designationMaster', { state: { designation: d } })
                    }
                    className="text-dorika-blue hover:text-dorika-green"
                  >
                    <FaEdit />
                  </button>
                  <button
                    onClick={() => deleteDesignation(d._id)}
                    className="text-dorika-orange hover:text-red-700"
                  >
                    <FaTrash />
                  </button>
                </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center py-4 text-gray-500">
                No designations found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
      {perPage !== "all" && (
        <Pagination
          total={designations.length}
          perPage={perPage}
          currentPage={currentPage}
          onPageChange={setCurrentPage}
        />
      )}
    </div>
</div>
</div>
  );
};

export default DesignationList;
